var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.content)?_c('vue-simple-markdown',{staticClass:"md-body",class:_vm.classes,attrs:{"source":_vm.content}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }